import { render, staticRenderFns } from "./AssessmentShowSection.vue?vue&type=template&id=2250c846"
import script from "./AssessmentShowSection.vue?vue&type=script&lang=js"
export * from "./AssessmentShowSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports